webpackJsonp([149606718003903],{

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;'); /* eslint-disable no-undef, react/prop-types */
	
	
	var tekijaStyle = /*#__PURE__*/(0, _reactEmotion.css)('h3{margin-top:0.1em;margin-bottom:0.1em;}margin-top:2em;');
	
	var imgStyle = /*#__PURE__*/(0, _reactEmotion.css)('border-radius:5px;margin-bottom:1em;');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:8em;margin-left:auto;margin-right:auto;');
	
	var Tekijat = function Tekijat(_ref) {
	  var data = _ref.data;
	  var elena = data.elena,
	      mika = data.mika,
	      kaisa = data.kaisa,
	      hanna = data.hanna,
	      erja = data.erja;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        className: style,
	        width: [1, 1, 1 / 2],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.secondary
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Tekij\xE4t'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tekijaStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Elena Vuoksiola',
	          sizes: elena.childImageSharp.sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Elena Vuoksiola'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'K\xE4sikirjoittaja, ohjaaja'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tekijaStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Hanna Poikela',
	          sizes: hanna.childImageSharp.sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Hanna Poikela'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Koreografi, tuottaja'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tekijaStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Erja Mesim\xE4ki',
	          sizes: erja.childImageSharp.sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Erja Mesim\xE4ki'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'S\xE4velt\xE4j\xE4'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tekijaStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Kaisa Alatalo',
	          sizes: kaisa.childImageSharp.sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Kaisa Alatalo'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Suunnittelija, j\xE4rjest\xE4j\xE4 harjoituskaudella'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tekijaStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Mika Ryyn\xE4nen',
	          sizes: mika.childImageSharp.sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Mika Ryyn\xE4nen'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Valosuunnittelija'
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Tekijat;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tekijat-js-0aa6f5de5fdef4212f75.js